import type { Tone } from '../../components/common/ui-kit';
import type { RagVersionStatus } from '../../types';

/** One meaning, one colour: a version status looks the same on the list, the
 *  version table, the designer and the playground. */
export const versionTone = (s?: RagVersionStatus | null): Tone => {
  switch (s) {
    case 'ACTIVE': return 'success';
    case 'CANDIDATE': return 'info';
    case 'EVAL_FAILED': return 'danger';
    case 'RETIRED': return 'neutral';
    default: return 'warn';
  }
};
